import styled from 'styled-components';

const Page = styled.div`
    margin-top: 20px;
`;

export default Page;